import React, { useEffect, useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import Toast from "react-hot-toast";
import add_stock from "../../Assets/svg/stockExchange/add_stock.svg";
import { post } from "../../helpers/api_helper";
import { useSelector } from "react-redux";
import OTPInput from "react-otp-input";
import ResetPasswordForm from "../shared/ResetPasswordForm";

const ResetMaterPasswordPopup = ({
  showModal,
  setShowModal,
  otpSent,
  timer,
  setTimer,
  isTimerActive,
  setIsTimerActive,
  resetCallback
}) => {
  const { email } = useSelector(state => state.login.userData)
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [showTryAgain, setShowTryAgain] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  useEffect(() => {
    if (isTimerActive && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (timer === 0) {
      setIsTimerActive(false);
      setTimer(15);
    }
  }, [isTimerActive, timer]);

  const handleResendOtp = async () => {
    if (resendCount < 3) {
      setLoading(true);
      try {
        const response = await post("/user/forgot/password", { email: email });
        if (response?.success) {
          Toast.success("OTP resent!");
          setResendCount((prev) => prev + 1);
          setIsTimerActive(true);
          if (resendCount === 0) {
            setTimer(15);
          } else {
            setTimer(30);
          }
        }
      } catch (error) {
        console.error("Failed to resend OTP", error);
      } finally {
        setLoading(false);
      }
    } else {
      setShowTryAgain(true);
      Toast.error("Maximum resend limit reached.");
    }
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    try {
      let values = { email: email, otp: otp };
      const response = await post("/user/verify/otp", values);
      if (response?.success) {
        setOtpVerified(true)
        Toast.success(response?.message);
      }
    } catch (error) {
      console.error("Failed to verify OTP", error);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      const response = await post("/user/admin/reset-master-password", {
        otp,
        email: email,
        newPassword: values.password,
      });
      setSubmitting(false);
      if (response?.success) {
        Toast.success(response.message);
        resetCallback();
      }
    } catch (error) {
      console.error("Error resetting password:", error?.message);
      setSubmitting(false);
    }
  }

  return (
    <Modal
      show={showModal}
      size="md"
      onHide={() => setShowModal(false)}
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Body>
        <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
          <div className="left">
            <h5 className="m-0 fw-sbold">
              Reset Master Password
            </h5>
          </div>
          <Button
            className="p-0 border-0"
            variant="transparent"
            onClick={() => setShowModal(false)}
          >
            <img src={add_stock} alt="" />
          </Button>
        </div>
        <div className="FormWrapper">
          {otpSent && !otpVerified && (
            <>
              <Col lg="12" className="my-3">
                <div className="FormHeading">
                  <h4 className="m-0 fw-sbold themeClr">Verification Code</h4>
                  <p className="m-0">
                    Please type the verification code sent to{" "}
                    <span className="themeClr">{email}</span>
                  </p>
                </div>
              </Col>
              <Col lg="12" className="my-3">
                <div className="otp mb-3">
                  <OTPInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>
                <p className="text-muted fw-sbold m-0">
                  I don’t receive a code!{" "}
                  {showTryAgain ? (
                    <span
                      className="themeClr fw-sbold"
                      role="button"
                      onClick={() => window.location.reload()}
                    >
                      Try again
                    </span>
                  ) : (
                    <Button
                      className="p-0 border-0 themeClr fw-sbold"
                      variant="transparent"
                      onClick={handleResendOtp}
                      disabled={loading || isTimerActive}
                      style={{
                        color: isTimerActive ? "lightgray" : "blue",
                        pointerEvents: isTimerActive ? "none" : "auto",
                      }}
                    >
                      {isTimerActive
                        ? `Please Resend in ${timer}s`
                        : "Please Resend"}
                    </Button>
                  )}
                </p>
              </Col>
              <Col lg="12" className="my-3">
                <Button
                  onClick={handleVerifyOtp}
                  className="d-flex align-items-center justify-content-center w-100 commonBtn"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Done"}
                </Button>
              </Col>
            </>
          )}
          {otpVerified && (
            <ResetPasswordForm
              onSubmit={handleResetPassword}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResetMaterPasswordPopup;
